export function initAutocomplete(onChange: () => void) {
    const input = document.getElementById("sl-autocomplete") as HTMLInputElement;
    if (!input) return;

    const options = {
        types: ["(regions)"],
        componentRestrictions: { country: "fr" },
    };

    const searchBox = new google.maps.places.Autocomplete(input, options);

    google.maps.event.addListener(searchBox, "place_changed", async function () {
        // @ts-ignore
        const place = searchBox.getPlace ? searchBox.getPlace() : searchBox.getPlaces()[0];
        if (!place || !place.geometry) return;

        const coordinates_input = document.querySelector(`input[name="coordinates"]`) as HTMLInputElement;
        const location_input = document.querySelector(`input[name="location"]`) as HTMLInputElement;

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        coordinates_input.value = `${lat},${lng}`;

        let city = "";
        if (place.address_components) {
            for (const comp of place.address_components) {
                if (comp.types.includes("locality")) {
                    city = comp.long_name;
                    break;
                }
            }
        }
        if (city) location_input.value = city;

        onChange();
    });
}
